import { defineMessages } from 'react-intl';

export const intlMessages = defineMessages({
  shiftAvailability: {
    defaultMessage: 'Shift Availability',
    description: 'Shift Availability',
    id: 'components.Core.AvailabilityShiftsInput.shiftAvailability',
  },
});
